import TableActions from './TableActions'

export default TableActions



// WEBPACK FOOTER //
// ./src/legacy/containers/Tables/Crpcomponents/TableActions/index.js